// @ts-nocheck
// Greif UI Kit = line-order-upload
import React from "react";

const OrderUploadLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M18 20v2H6v-2zM4 20V4a2 2 0 0 1 2-2h8.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V20a2 2 0 0 1-2 2V7.828L14.172 4H6v18a2 2 0 0 1-2-2"
            />
            <path
                fill="currentColor"
                d="M12.5 7.5V4h2v3.5H18v2h-3.5a2 2 0 0 1-2-2M11.03 20v-6.052l-1.702 2.089a.96.96 0 0 1-1.369.076.99.99 0 0 1-.076-1.386l2.937-3.317.025-.03.03-.028c.33-.317.751-.443 1.125-.443.373 0 .795.126 1.125.443l.03.028.025.03 2.936 3.317a.99.99 0 0 1-.075 1.386.96.96 0 0 1-1.37-.076l-1.701-2.09V20z"
            />
        </svg>
    );
};

export default React.memo(OrderUploadLine);
